import { Image } from "grommet";

const MapboxLogoBlack = ({ height = "10px" }: { height?: string }) => (
  <Image
    height={height}
    a11yTitle="Mapbox logo"
    src={process.env.PUBLIC_URL + "/mapbox-logo-black.png"}
  />
);

export default MapboxLogoBlack;
